import styled from "styled-components";
import { Row } from "../../components/styled/Flex";

export const TransactionProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  @media screen and (max-width: 768px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const WrappedRow = styled(Row)`
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
`;
